'use client';

import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Slot } from '../slot';
import { InlineFeedbackRootContext } from './context/inline-feedback-root.context';
import { inlineFeedbackRootStyles } from './styles/inline-feedback-root.styles';
import type { InlineFeedbackRootPropsInterface } from './types/inline-feedback-root.types';

/**
 * @since 7.17.0
 */
export const InlineFeedbackRoot = forwardRef<
  HTMLParagraphElement,
  InlineFeedbackRootPropsInterface
>((props: InlineFeedbackRootPropsInterface, forwardedRef) => {
  const { tone = 'info', asChild = false, children, className, css: cssProp, ...rest } = props;

  const styles = css(inlineFeedbackRootStyles, cssProp);

  const Component = asChild ? Slot : 'p';

  return (
    <InlineFeedbackRootContext.Provider value={{ tone }}>
      <Component
        ref={forwardedRef}
        data-c11n-component="InlineFeedback.Root"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', styles, className)}
        {...rest}
      >
        {children}
      </Component>
    </InlineFeedbackRootContext.Provider>
  );
});

InlineFeedbackRoot.displayName = 'InlineFeedback.Root';
